import Cookies from "js-cookie";
import { isBrowser } from "../../../utils/ssr";

export function getContentOrigin() {
  const queryParams = new URLSearchParams((isBrowser() && window?.location.search) || "");

  let queryStringContent = queryParams.get("content");

  const mealplanRedirectCookie = Cookies.get("mealplan-redirect");
  if (mealplanRedirectCookie) {
    queryStringContent = "personalized-meal-plan";
  }

  return queryStringContent || null;
}
